<template>
  <v-app id="app" class="mh-app-component">
    <router-view> </router-view>
      <LoadingOverlay />
      <NotificationHandler />

  </v-app>
</template>
<script>
import LoadingOverlay from "@/project/pages/components/loading-overlay.vue"
import NotificationHandler from "@/project/pages/components/notification-handler.vue"

export default {
    components: {
        LoadingOverlay,
        NotificationHandler
    }

};
</script>

<style>
</style>


